// import * as React from "react";
import React, { FC, ReactElement } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import RightDrawer from "../components/RightSidebar/DrawerRight";
import SecondaryDrawerRight from "../components/RightSidebar/SecondaryRightDrawer";
import LeftSidebar from "../components/LeftSidebar";
import ChatSection from "../components/ChatSection";
import Navbar from "../components/Navbar";
import { useAppDispatch } from "../hooks/reduxhook";
import apiCall from "../utils/apiCall";
import {
  GET_USER_CONVERSATIONS,
  GET_USER_DETAILS,
  GET_USER_FOLDERS,
  WAKE_UP_SQL_DB,
} from "../endpoint";
import ReactJoyride, { STATUS, Step } from "react-joyride";
import { addUserDetails, getuser } from "../redux/slices/userSlice";
import { addConversations } from "../redux/slices/conversationSlice";
import {
  loadingforconversation,
  loadingforfullscreen,
} from "../redux/slices/loadingSlice";
import { PENDING } from "../data/constants";
import { addError } from "../redux/slices/errorSlice";
import { useSelector } from "react-redux";
import { locale, styles } from "../components/JoyRideSteps";
import JoyRideComponent from "../components/JoyRideComponent";
import {
  adddrawerOpening,
  isdrawerOpening,
  removedrawerOpening,
} from "../redux/slices/drawerOpening";
import { generateJoyRideSteps } from "../components/GenerateJoyRideStep";
import aws_svg from "../assets/aws.svg";
import useJoyRide from "../components/useJoyRide";
interface i_props {
  logoUrl: string;
}
const Playground: FC<i_props> = ({ logoUrl }): ReactElement => {
  const [secondaryOpen, setSecondaryOpen] = React.useState(true);
  const { isJoyRideRunning, joyRideSteps, startJoyRide, setIsoyRideRunning } =
    useJoyRide();
  const navigate = useNavigate();

  const { accounts } = useMsal();
  const account = accounts[0];

  const dispatch = useAppDispatch();

  const { instance } = useMsal();

  const open = useSelector(isdrawerOpening);
  const user = useSelector(getuser);

  React.useEffect(() => {
    const fetch_data = () => {
      dispatch(loadingforconversation(true));
      dispatch(loadingforfullscreen(true));
      // apiCall("GET", WAKE_UP_SQL_DB);
      apiCall("POST", GET_USER_DETAILS)
        .then((res) => {
          if (res.request === PENDING || res.request === "none") {
            navigate("/noaccess");
          } else {
            dispatch(addUserDetails(res?.result));
            dispatch(loadingforfullscreen(false));
            apiCall("POST", GET_USER_CONVERSATIONS, {
              user_email: account.username,
            })
              .then((res) => {
                dispatch(addConversations(res?.result));
              })
              .catch((err) => {
                dispatch(
                  addError(
                    "Failed to load user conversations.Please try again.",
                  ),
                );
              })
              .finally(() => {
                dispatch(loadingforconversation(false));
              });
          }
        })
        .catch((err) => {
          dispatch(addError("Failed to load user details.Please try again."));
          // instance.logoutRedirect({
          //   postLogoutRedirectUri: "",
          // });
        })
        .finally(() => {
          dispatch(loadingforfullscreen(false));
        });
    };
    fetch_data();
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Navbar onStartJoyRide={startJoyRide} logoUrl={logoUrl} />
      <JoyRideComponent
        steps={joyRideSteps}
        isJoyRideRunning={isJoyRideRunning}
        onFinish={() => setIsoyRideRunning(false)}
      />
      <LeftSidebar />
      <ChatSection />
      {user.user_email && (
        <RightDrawer
          open={open}
          setOpen={() => dispatch(removedrawerOpening())}
        />
      )}
      {!open && user.user_email && (
        <SecondaryDrawerRight
          open={secondaryOpen}
          setOpen={(value: boolean) => setSecondaryOpen(value)}
        />
      )}
    </Box>
  );
};

export default Playground;
